import { RouteTabs } from '@/shared/ui/route-tabs';
import { SCRAPER_TABS } from '../model/scraper-routes';

/**
 * The sidebar carries one Scraper entry rather than one per screen, because
 * `activeNavItem` is longest-prefix and highlights it on every route below; the
 * screens navigate between each other from here.
 */
export function ScraperTabs() {
  return <RouteTabs tabs={SCRAPER_TABS} label="Scraper sections" />;
}
